module.exports = __webpack_public_path__ + "static/media/esus.c7bb5fe4.svg";